import { render } from "./Pipelines.vue?vue&type=template&id=c20a00d8"
import script from "./Pipelines.vue?vue&type=script&lang=js"
export * from "./Pipelines.vue?vue&type=script&lang=js"

import "./Pipelines.vue?vue&type=style&index=0&id=c20a00d8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__